// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { ExternalLink } from '@/components/external-link';
import {
  ShippingCarrier,
  getTrackingURLForShippingCarrier,
} from '@/constants/shipping-carrier';

interface Props {
  carrier: ShippingCarrier | null | undefined;
  identifier: string | null;
}

/** Renders an identifier, linked to the carrier's tracking page when it has one. */
export function AuditCarrierLinkValue(props: Props) {
  const url =
    props.carrier && props.identifier
      ? getTrackingURLForShippingCarrier(props.carrier, props.identifier)
      : null;

  if (url === null || props.identifier === null) {
    return <AuditPropertyValue value={props.identifier} />;
  }

  return <ExternalLink href={url}>{props.identifier}</ExternalLink>;
}
